import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "trigger", "tooltipClassname", "className", "triggerDataTestId", "open", "onOpenChange", "tabIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useUncontrolledProp } from 'uncontrollable';
import { QuestionSVG } from '@sbercloud/uikit-product-icons';
import { MobileTooltip } from '../MobileTooltip';
import { SIZE, SIZES_MAP, TRIGGER, TRIGGER_MAP } from './constants';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function MobileQuestionTooltip(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE.Xs : _ref$size,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? TRIGGER.Hover : _ref$trigger,
    tooltipClassname = _ref.tooltipClassname,
    className = _ref.className,
    triggerDataTestId = _ref.triggerDataTestId,
    open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useUncontrolledProp = useUncontrolledProp(open, false, onOpenChange),
    _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
    isOpen = _useUncontrolledProp2[0],
    setIsOpen = _useUncontrolledProp2[1];
  return /*#__PURE__*/_jsx(MobileTooltip, _objectSpread(_objectSpread({}, rest), {}, {
    className: tooltipClassname,
    open: isOpen,
    onOpenChange: setIsOpen,
    trigger: TRIGGER_MAP[trigger],
    children: function children(_ref2) {
      var getReferenceProps = _ref2.getReferenceProps,
        ref = _ref2.ref;
      return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, getReferenceProps({
        onClick: function onClick(event) {
          return event.stopPropagation();
        }
      })), {}, {
        ref: ref,
        "data-size": size,
        "data-opened": isOpen,
        "data-trigger": trigger,
        className: cn(styles.questionTooltip, className),
        role: "button",
        tabIndex: tabIndex,
        children: /*#__PURE__*/_jsx(QuestionSVG, {
          size: SIZES_MAP[size],
          "data-test-id": triggerDataTestId
        })
      }));
    }
  }));
}